module.exports = __webpack_public_path__ + "img/right-arrow-arrow.aa298292.svg";